// extracted by mini-css-extract-plugin
module.exports =  {"copy":"OkkasT9p","heading":"YNuNL2Eu","subheading":"_5mkA5fz3"};